import React, { Fragment } from 'react'
import classnames from 'classnames'

import { useFloorState } from '../../firebase/hooks/useFloor'
import { useEditingMixState } from '../../firebase/hooks/useMixes'
import { useRole } from '../../global/blocs/roomInfo'
import { useSortedHumanParticipants } from '../../webrtc/webRTCRoom'
import useFeatures from '../../sharedLegacy/hooks/useFeatures'
import { MixEditingToolbar } from '../MixEditingToolbar/MixEditingToolbar'

import { EmptyMixSlots } from './EmptyMixSlots/EmptyMixSlots'
import { FloorCameraFeed } from './FloorFeed/FloorCameraFeed/FloorCameraFeed'
import { FloorMobileFeed } from './FloorFeed/FloorMobileFeed/FloorMobileFeed'
import { FloorScreenFeed } from './FloorFeed/FloorScreenFeed/FloorScreenFeed'
import { FloorTrayFeed } from './FloorFeed/FloorTrayFeed/FloorTrayFeed'

import './floor.scss'

const Floor = () => {
  const floor = useFloorState()
  const participants = useSortedHumanParticipants()
  const editingMix = useEditingMixState()
  const role = useRole()

  const { HasTransitionsEnabled } = useFeatures()

  if (!floor) return null

  const identifier = 'identifier' in floor ? floor.identifier : undefined

  return (
    <div
      className={classnames('floor', {
        'transitions-enabled': HasTransitionsEnabled,
        'editing-mix': editingMix,
      })}
      data-layout={floor.layout}
      data-identifier={identifier}
    >
      {participants.map((participant) => (
        <Fragment key={participant.id}>
          <FloorCameraFeed id={participant.id} />
          <FloorScreenFeed id={participant.id} />
          <FloorMobileFeed id={participant.id} />
        </Fragment>
      ))}
      <FloorTrayFeed />

      {role === 'producer' && (
        <>
          <EmptyMixSlots />
          <MixEditingToolbar />
        </>
      )}
    </div>
  )
}

export { Floor }
